<template>
  <div class="d-flex flex-column" style="gap: 5px;">
    <span class="text-caption text-uppercase font-weight-medium grey--text">
      {{ label }}
    </span>
    <v-text-field
      :value="value"
      type="number"
      :min="min"
      :max="max"
      :step="step"
      :suffix="unit"
      :readonly="readonly"
      :disabled="readonly"
      outlined
      rounded
      dense
      hide-details
      @input="onInput"
    />
  </div>
</template>

<script>
/**
 * Campo numérico libre del kit de condiciones.
 *
 * El slider no sirve para importes en euros con rangos amplios (0-9999): sería
 * imposible afinar. Este campo cubre los settings declarados como "currency" o
 * "number" en el settings_schema del tipo.
 */
export default {
  name: "a-pricing-strategy-rule-type-condition-field-number",
  props: {
    value: { type: Number, default: 0 },
    min: { type: Number, default: 0 },
    max: { type: Number, default: 9999 },
    step: { type: Number, default: 1 },
    label: { type: String, default: "" },
    unit: { type: String, default: "" },
    readonly: { type: Boolean, default: false }
  },
  methods: {
    onInput(v) {
      if (v === "" || v === null) {
        this.$emit("input", null);
        return;
      }
      const number = Number(v);
      if (Number.isNaN(number)) return;
      this.$emit("input", Math.min(this.max, Math.max(this.min, number)));
    }
  }
};
</script>
